import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CardInput" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  class: "input",
                  modelValue: _ctx.handString,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.handString) = $event)),
                  outlined: "",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "CardInput__Result" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          justify: "center",
          class: "CardInput__Button"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.draw,
                  color: "orange lighten-4",
                  block: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("draw")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.judge,
                  color: "orange lighten-4",
                  block: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("judge")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.reset,
                  color: "white lighten-4",
                  block: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("reset")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_v_row, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.close,
                  color: "white lighten-4",
                  block: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("finish")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.isIframe]
        ])
      ]),
      _: 1
    })
  ]))
}